import { getStudyYearDataByDate } from '../legacyComponents/utils/helpers';
import { callWithCache } from '../utils/callWithCache';

export const configurationsService = {
  loadSchoolYearRange: async () => {
    return new Promise(resolve => {
      const dates = getStudyYearDataByDate(new Date());
      resolve({
        start: dates.start.toString(),
        end: dates.end.toString()
      });
    });
  },

  loadLabels: async (systemLanguages = ['he', 'ar']) => {
    const isIvritIL = systemLanguages.includes('ivritil');
    const languages = systemLanguages.map(lang => (lang === 'ivritil' ? 'en' : lang)).join(',');
    const params = { languages, ...(isIvritIL && { workspace: 'ivritil' }) };
    const result = await callWithCache(window.cet.microservices.nairobiapi.label.getLabels, 'getLabels', params, 3);
    if (isIvritIL && result?.en) {
      result.ivritil = result.en;
    }
    return result;
  },

  loadAllDisciplines: async lang => callWithCache(window.cet.microservices.contentapi.content.getDimension, 'allDisciplines', { lang: lang === 'ivritil' ? 'en' : lang, dimension: 'disciplines' }),

  loadAllDimensions: async lang => callWithCache(window.cet.microservices.contentapi.content.getAllDimensionsByLanguage, 'allDimensions', { lang: lang === 'ivritil' ? 'en' : lang }),

  loadAllDependencies: async lang => callWithCache(window.cet.microservices.contentapi.content.getAllDependencies, 'allDependencies')
};
